import { useEffect, useCallback, useReducer } from 'react';
export function useCache(cache, key) {
    const [state, dispatch] = useReducer(reducer, undefined, () => cache.get(key));
    const updateHandler = useCallback((event) => {
        if (!event) {
            return dispatch(void 0);
        }
        if (event.key === key) {
            dispatch(event.value);
        }
    }, [key]);
    useEffect(() => {
        const cachedState = cache.get(key);
        if (state !== cachedState) {
            dispatch(cachedState);
        }
        cache.on('clear', updateHandler);
        cache.on('update', updateHandler);
        return () => {
            cache.off('clear', updateHandler);
            cache.off('update', updateHandler);
        };
    }, [updateHandler]);
    return cache.get(key);
}
function reducer(_, payload) {
    return payload;
}
//# sourceMappingURL=useCache.js.map